// src/services/WishlistManager.js
import userAxios from "../../utils/userAxios"; // for user

const BASE_URL = "/wishlist"; // relative to /api

const WishlistManager = {
  // 🟩 Get all wishlist items for a user
  async getWishlistByUser(userId) {
    const response = await userAxios.get(`${BASE_URL}/list`, {
      params: { userId },
    });
    return response.data.responseData;
  },

  // 🟩 Add a book to the user's wishlist
  async addToWishlist(userId, bookId) {
    const payload = { userId, bookId };
    const response = await userAxios.post(`${BASE_URL}/add`, payload);
    return response.data.responseData;
  },

  // 🟩 Remove a specific book from the wishlist
  async removeFromWishlist(userId, bookId) {
    const payload = { userId, bookId };
    const response = await userAxios.delete(`${BASE_URL}/remove`, {
      data: payload,
    });
    return response.data.responseData;
  },
};

export default WishlistManager;
